// @ts-strict-ignore
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomValidators } from '@shared/custom-validators';
import { ArticleNumberMappingListVO } from '../../../model/vo/article-number-mapping.vo';

/**
 * Component to add/edit a custom article number list
 * It is accessible via the user settings
 */
@Component({
  standalone: false,
  selector: 'custom-article-number-list',
  templateUrl: './edit-custom-article-number-list.component.html'
})
export class EditCustomArticleNumberListComponent implements OnInit {

  private readonly MAX_ARTICLE_NUMBER_LIST_NAME_LENGTH: number = 200;

  @Output() public finish = new EventEmitter<ArticleNumberMappingListVO | null>();

  public form: FormGroup;

  constructor(private fb: FormBuilder, private bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      listName: ['', [CustomValidators.trimRequired, CustomValidators.maxLength(this.MAX_ARTICLE_NUMBER_LIST_NAME_LENGTH)]]
    });
  }

  public close(): void {
    this.finish.emit(null);
    this.bsModalRef.hide();
  }

  public accept(): void {
    if (!this.form.valid) {
      return;
    }
    const newArticleNumberMappingList: ArticleNumberMappingListVO = new ArticleNumberMappingListVO();
    newArticleNumberMappingList.name = this.form.value.listName.trim();
    newArticleNumberMappingList.isDefault = false;
    newArticleNumberMappingList.isActive = true;
    newArticleNumberMappingList.entries = [];
    this.finish.emit(newArticleNumberMappingList);
    this.bsModalRef.hide();
  }

}
